Array.from(document.querySelectorAll('.rte iframe')).forEach(function (iframe) {
    // We scope the wrapping only for YouTube and Vimeo
    if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
      iframe.outerHTML = '<div class="videoWrapper">' + iframe.outerHTML + '</div>';

      // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar
      iframe.src = iframe.src;
    }
})